const HOME = {
  WEBSITES_LIST_TITLE: "You have access to the following websites",
  NO_WEBSITES_ADDED_TITLE: "You have not added any websites yet.",
  ADD_NEW_WEBSITE: "Add new website",
  WELCOME: "Welcome",
};

export default HOME;
